<p>landing worksss!</p>
<div *ngFor="let list_user of list_user_rows">
    <p>{{list_user.name}}</p>
</div>
<img src={{imageUrl}} />
